import { render, staticRenderFns } from "./VTag.vue?vue&type=template&id=1228f826&scoped=true&"
import script from "./VTag.vue?vue&type=script&lang=js&"
export * from "./VTag.vue?vue&type=script&lang=js&"
import style0 from "./VTag.vue?vue&type=style&index=0&id=1228f826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1228f826",
  null
  
)

export default component.exports